import { render, staticRenderFns } from "./MemberCenterAdminEmailArchive.vue?vue&type=template&id=680f0b03&scoped=true&lang=pug&"
import script from "./MemberCenterAdminEmailArchive.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminEmailArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f0b03",
  null
  
)

export default component.exports